import { Box, BoxProps, Button, Grid, Stack, Typography } from "@mui/material"
import { IDataDetalharTitulosReceber } from "../../../../../../../types/api/financeiro/datalhar-titulos-receber"
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { DadosTitulosItems } from "..";
import { useState } from "react";
import { verificarStringVazia } from "../../../../../../../helpers/verificadores";
import tratativaDeDatas from "../../../../../../../helpers/tratativaDeDatas";
import DialogEdit from "./DialogEdit";
import { usePermission } from "../../../../../../../components/PermissionGuard";

export default function CardDadosAdicionais({
    boxStyle, detalhe, codigo
}: CardDadosAdicionaisProps) {

    const podeEditar = usePermission('financeiro.contas-receber-editar')

    const [openEdit, setOpenEdit] = useState(false)

    return (
        <Box {...boxStyle}>
            <Typography variant="h6">Dados complementares</Typography>

            <Grid container rowGap={2}>
                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Loja" valor={detalhe.loja ? `${detalhe.loja.id} - ${detalhe.loja.nome}` : "-"} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Comprador" valor={verificarStringVazia(detalhe.comprador)} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Grupo" valor={`${detalhe.grupo_recebimento || "-"}`} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Borderô" valor={detalhe.bordero} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Boleto" valor={detalhe.boleto} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Tipo D/C" valor={detalhe.tipo_debito_credito} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Libera Rem. FAT-ANT" valor={detalhe.liberado_remessa_faturamento_antecipado === "S" ? "Sim" : "Não"} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Autorização cartão" valor={verificarStringVazia(detalhe.autorizacao_cartao)} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Parcela" valor={`${detalhe.parcela_cartao}`} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Resumo lote" valor={`${detalhe.resumo_lote_cartao}`} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Comprovante de venda" valor={`${detalhe.comprov_venda_cartao}`} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="NSU" valor={`${detalhe.nsu_cartao}`} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Deb/Cred" valor={verificarStringVazia(detalhe.deb_cred_cartao)} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Centro custo fiscal" valor={detalhe.centro_custo_fiscal ? `${detalhe.centro_custo_fiscal.id} - ${detalhe.centro_custo_fiscal.nome}` : "-"} />
                </Grid>
            </Grid>

            <Typography mb={1} variant="h6">Dados contábeis</Typography>

            <Grid container rowGap={2}>
                <Grid size={{xs: 6}}>
                    <Stack>
                        <Typography fontWeight="bold" variant="subtitle2">Conta contábil</Typography>
                        <Stack>
                            <Typography variant="subtitle2">
                                {detalhe.conta_contabil ?
                                    `${detalhe.conta_contabil.codigo_contabil} - ${detalhe.conta_contabil.nome}` : "-"}
                            </Typography>
                            {
                                detalhe.conta_contabil_custo &&
                                <Typography variant="caption" color="gray">
                                    Centro custo: {`${detalhe.conta_contabil_custo.id} - ${detalhe.conta_contabil_custo.nome}`}
                                </Typography>
                            }
                        </Stack>
                    </Stack>
                </Grid>

                <Grid size={{xs: 6}}>
                    <Stack>
                        <Typography fontWeight="bold" variant="subtitle2">Contra partida</Typography>
                        <Stack>
                            <Typography variant="subtitle2">
                                {detalhe.contra_partida ?
                                    `${detalhe.contra_partida.codigo_contabil} - ${detalhe.contra_partida.nome}` : "-"}
                            </Typography>
                            {
                                detalhe.contra_partida_custo &&
                                <Typography variant="caption" color="gray">
                                    Centro custo: {`${detalhe.contra_partida_custo.id} - ${detalhe.contra_partida_custo.nome}`}
                                </Typography>
                            }
                        </Stack>
                    </Stack>
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Inicio cálculos" valor={tratativaDeDatas(detalhe.data_inicio_calculo)} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Última capitalização" valor={tratativaDeDatas(detalhe.data_ultima_capitalizacao)} />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Data atualização" valor={tratativaDeDatas(detalhe.data_ultima_atualizacao)} />
                </Grid>
            </Grid>

            {
                podeEditar &&
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<EditOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={() => setOpenEdit(true)}
                    >
                        Editar
                    </Button>
                </Stack>
            }

            {
                openEdit &&
                <DialogEdit
                    {...{ codigo }}
                    open={openEdit}
                    handleClose={() => setOpenEdit(false)}
                    titulo={detalhe}
                />
            }
        </Box>
    )
}

interface CardDadosAdicionaisProps {
    boxStyle: BoxProps,
    codigo: string,
    detalhe: IDataDetalharTitulosReceber
}